var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert"},[_vm._l((_vm.alerts),function(alert){return [_c('DefaultAlert',{key:alert.id,attrs:{"alert":alert},on:{"close":function($event){return _vm.storeRemoveAlert(alert.id)}}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }